import React from 'react';
import { LocalAudioTrack } from 'twilio-video';
import { Grid, Typography } from '@material-ui/core';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import AudioLevelIndicator from '../AudioLevelIndicator/AudioLevelIndicator';

interface LocalAudioLevelIndicatorProps {
    showLabel?: boolean;
}

export default function LocalAudioLevelIndicator({ showLabel }: LocalAudioLevelIndicatorProps) {
    const { localTracks } = useVideoContext();
    const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;

    return (
        <Grid container xs={12} direction="row">
            {showLabel && <Typography>{audioTrack.mediaStreamTrack.label}</Typography>}
            <AudioLevelIndicator audioTrack={audioTrack} color="black" />
        </Grid>
    );
}
